/**
 * Fixes blog post grids.
 */

( function($) {

    $(window).load(
        function() {

            // Some things we need
            var localLinkTest = new RegExp( window.location.host );

            // Disable Ajax
            $( '.et_pb_blog_grid .pagination a' ).click( function() {
                window.location.href = $(this).attr('href');
                return false;
            });

            // Fix external links
            function fixExternalLinks( blogModules ) {

                var links = blogModules.find( '.entry-title a' );

                links.each( function( index, link ) {

                    link = $( link );

                    if ( ! localLinkTest.test( link.attr( 'href' ) ) ) {
                        link.attr( 'target', '_blank' );
                    }
                } );
            }
                            
            // Define function to equalize one blog
            function equalizeOneBlogGrid( blogModule = null ) {

                // First, we need to create a model of the rows from the columns we know to exist
                var rows = [];
                var columns = blogModule.find( '.column' );
                
                columns.each(
                    function( columnIndex, column ) {
                    
                        var posts = $( column ).find( '.et_pb_post' );
                        
                        posts.each(
                            function( postIndex, post ) {
                                
                                if ( ! rows[postIndex] ) {
                                    rows[postIndex] = [];
                                }
                                
                                rows[postIndex].push( post );
                            }
                        );
                    }
                );
                
                rows = $( rows.map( $ ) );
                
                // Then, iterate through them
                rows.each(
                    function( index, row ) {
                        
                        // Then, determine the tallest card in each row
                        var posts = $( row );
                        var heights = [];
                        
                        posts.each( function( index, post ) {

                            post = $( post );
                            post.css( 'height', '' );
                            heights.push( $( post ).outerHeight() );
                        } );

                        // Finally, set the height of all cards to equal that of the tallest
                        posts.css( 'height', Math.max.apply( Math, heights  ) );
                    }
                );					
            }

            // Define function to equalize a bunch of blog grids
            function equalizeBlogGrids( blogModules = null ) {

                blogModules.each(
                    function( index, equalHeightBlog ) {
                        equalizeOneBlogGrid( $( equalHeightBlog ) );						
                    }
                );
            }

            // Get blog grids and determine if we should equalize
            var equalHeightBlogs = $( '.et_pb_blog_grid' );

            if( equalHeightBlogs.length ) {

                fixExternalLinks( equalHeightBlogs );
                equalizeBlogGrids( equalHeightBlogs );

                $(window).on(
                    'resize',
                    function( event ) {
                        equalizeBlogGrids( equalHeightBlogs );
                    }
                );

                var observer = new MutationObserver( function( mutations ) {
                    fixExternalLinks( equalHeightBlogs );
                    equalizeBlogGrids( equalHeightBlogs );
                } );

                equalHeightBlogs.each( function( index ) {
                    observer.observe(
                        equalHeightBlogs.get( index ),
                        {
                            attributes    : true,
                            childList     : true,
                            characterData : true
                        }
                    );
                } );                
            }
        }
    );
	
    
} )( jQuery );